import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import type { ButtonProps } from 'antd';
import { useAuth } from '../../auth/authcontext';

interface FormButtonProps extends ButtonProps {
  title: string;
  icon?: React.ReactNode;
  onClick: () => void;
  tooltip?: string;
  disableClick?: boolean;
  forceShow?: boolean;
}

const FormButton: React.FC<FormButtonProps> = ({
  title,
  icon,
  onClick,
  tooltip,
  disableClick = false,
  forceShow = false,
  ...buttonProps
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { isReadOnly } = useAuth();

  const writeActionTitles = ['Save', 'Submit', 'Delete', 'Add', 'Add All', 'Remove All', 'Duplicate', 'Create', 'Done', 'Request Approval', 'Approve', 'Reject', 'Save Changes', 'Delete Group','Add Store','Create Role','Block','Unblock','Save Upsell'];
  if (isReadOnly && writeActionTitles.includes(title) && !forceShow) {
      return null; // hide button for read-only users
  }

  const buttonStyle: React.CSSProperties = {
    backgroundColor: 'var(--color-primary)',
    fontSize: '12px',
    ...(isHovered ? { backgroundColor: '#776ef0' } : {}),
    ...(disableClick ? { pointerEvents: 'none' } : {}),
  };

  const buttonContent = (
    <Button
      type="primary"
      variant="solid"
      size="small"
      style={buttonStyle}
      icon={icon}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...buttonProps}
    >
      {title}
    </Button>
  );

  return tooltip ? (
    <Tooltip title={tooltip} >
      {buttonContent}
    </Tooltip>
  ) : (
    buttonContent
  );
};

export default FormButton;

